(function () {
	'use strict';

	$(document).ready(function () {
		const calendarEl = document.getElementById('calendar')
		if (calendarEl) {
			const lang = document.documentElement.lang;
			const calendar = new FullCalendar.Calendar(calendarEl, {
				initialView: 'dayGridMonth',
				firstDay: 1,
				locale: lang,
				height: 'auto'
			})
			const articles = document.querySelectorAll('main.events article');
			let events = [];
			articles.forEach(function(article) {
				const title = article.getAttribute('data-title');
				const start = article.getAttribute('data-start-date');
				const end = article.getAttribute('data-end-date');
				const id = article.getAttribute('id');
				const url = '#' + id;

				events.push({
					title,
					start,
					end,
					url,
					classNames: ['scroll-animation']
				});
			});

			calendar.addEventSource(events);
			calendar.render()
		}

		$('.dictionary #slowo').on('keyup', function () {
			var searchTerm = $('.dictionary #slowo').val().toLowerCase();
			var dictionaryAllTerms = $('.dictionary .dictionary-all-terms');
			var dictionaryAllTermsItems = $('.dictionary .dictionary-all-terms li');

			if (searchTerm.length >= 3) {
				var termsFound = false;
				dictionaryAllTermsItems.each(function () {
					if ($(this).data('title').toLowerCase().indexOf(searchTerm) > -1) {
						$(this).show();
						termsFound = true;
					}
				});
				if (termsFound) {
					dictionaryAllTerms.fadeIn();
				}
			} else {
				dictionaryAllTerms.fadeOut(250, function () {
					dictionaryAllTerms.children().hide();
				});
			}
		});

		$('.dictionary-search-switch a').on('click', function () {
			var letterActive = $(this).attr('href');

			$(this).addClass('active').parent().siblings().children().removeClass('active');

			$('.dictionary-letter').removeClass('active');
			$(letterActive).addClass('active');
		});

		// responsive image enlarging
		$('.popup-trigger').click(function (e) {
			$(this).parent().find('.popup-image-container').fadeIn();
			e.preventDefault();
			return false;
		});

		$('.popup-image-container').click(function () {
			$(this).fadeOut();
		});

		$('.RadioInput.submit-on-change').change(function () {
			$(this).closest('form').submit();
		})

		// Video Module
		const playVideo = (video) => {
			video.play();
			video.classList.add('playing');
			video.parentElement.classList.add('playing');
		};

		const pauseVideo = (video) => {
			video.parentElement.classList.remove('playing');
			video.classList.remove('playing');
			video.pause();
		}

		const handleVideo = (video) => {
			if (video.paused) {
				playVideo(video);
			} else {
				pauseVideo(video);
			}
		}

		document.querySelectorAll('video').forEach((videoElement) => {
			videoElement.addEventListener('click', () => {
				handleVideo(videoElement);
			});
			videoElement.nextElementSibling.addEventListener('click', () => {
				handleVideo(videoElement);
			})
		});

		document.querySelectorAll('.external-videos-swiper').forEach((videoElement) => {
			const parent = videoElement.parentElement;
			new Swiper(videoElement, {
				autoHeight: true,
				navigation: {
					prevEl: parent.querySelector('.swiper-navigation-prev'),
					nextEl: parent.querySelector('.swiper-navigation-next'),
				},
			});
		});


		//Tooltipster
		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

		function updateTableSize() {
			$('.table-container').each(function () {
				if ($(this).parent().hasClass('panel-body')) return;
				var containerWidth = $(this).width();
				var tableWidth = $('table', this).width();

				if (tableWidth > containerWidth) {
					$(this).addClass('scrollable');
					$(this).mCustomScrollbar({
						axis: "x",
						mouseWheel: {
							enable: true
						}
					});
				} else {
					$(this).removeClass('scrollable');
					$(this).mCustomScrollbar('destroy');
				}
			});
		}

	});
}(jQuery));
